// https://github.com/quipper/school-comm-issues/issues/5546#issuecomment-2908461107
export const ShinroRelease = {
  current: 'w1',
  releases: {
    w1: {
      popupContent: 'お子さまの進路に役立つ\n情報の配信スタート！\n※試験運用中',
      popupNewBadge: true,
      lasted: false,
    },
    w2: {
      popupContent: 'お子さまの進路に役立つ\n情報が更新されました！',
      popupNewBadge: false,
      lasted: false,
    },
    w3: {
      popupContent: 'お子さまの進路に役立つ\n情報が更新されました！',
      popupNewBadge: false,
      lasted: false,
    },
    w4: {
      popupContent: 'お子さまの進路に役立つ\n情報が更新されました！',
      popupNewBadge: false,
      lasted: false,
    },
    w5: {
      popupContent: 'お子さまの進路に役立つ\n情報が更新されました！',
      popupNewBadge: false,
      lasted: true,
    },
    // アンケート
    survey: {
      popupContent: '今後のサービス提供のため\nアンケートにご協力ください',
      popupNewBadge: false,
      lasted: false,
    },
  },
};
